export default "__VITE_ASSET__CIJXt4Z___"